interface FavoriteBadgeProps {
  /** L'élément est-il déjà en favori ? */
  active: boolean;
  /** Bascule (ajoute / retire) le favori. */
  onToggle: () => void;
  /** Classes additionnelles (position absolue, etc.). */
  className?: string;
}

/**
 * Petit badge léger « déjà en favori », pensé pour les LISTES publiques
 * (produits, services…). Contrairement à `FavoriteButton` qui gère sa propre
 * requête, ce badge est purement visuel : l'état et le basculement sont fournis
 * par le parent, ce qui permet de l'afficher sur des dizaines de cartes sans
 * multiplier les requêtes. Il devient rouge et affiche « En favori » dès que
 * l'élément est enregistré.
 */
export default function FavoriteBadge({ active, onToggle, className = '' }: FavoriteBadgeProps) {
  return (
    <button
      type="button"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); onToggle(); }}
      title={active ? 'Déjà en favori — cliquer pour retirer' : 'Ajouter aux favoris'}
      aria-label={active ? 'Déjà en favori' : 'Ajouter aux favoris'}
      aria-pressed={active}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold transition-colors cursor-pointer whitespace-nowrap ${
        active
          ? 'bg-background-50/95 text-red-600 border border-red-200'
          : 'bg-background-50/90 text-foreground-500 border border-background-200/70 hover:bg-background-100 hover:text-foreground-700'
      } ${className}`}
    >
      <i className={`${active ? 'ri-heart-3-fill' : 'ri-heart-3-line'} text-sm leading-none`}></i>
      {active && <span>En favori</span>}
    </button>
  );
}